<template>
  <v-row no-gutters>
    <v-col v-if="!is_mobile_version">
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
          <v-row no-gutters>
            <v-col class="d-flex pa-0">
              <v-autocomplete
                v-model="location_selected"
                :items="locations_list"
                item-text="name"
                item-value="_guid"
                label="All locations"
                dense
                solo
                clearable
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <!-- Divider and Header-->
                  <!-- Area item (group) -->
                  <template v-if="data.item._guid.type == TYPE_AREA">
                    <div class="select-drop-item-group__area">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                  <!-- Restaurant item (sub group) -->
                  <template v-else>
                    <div class="select-drop-item-sub_restaurant">
                      <div v-html="data.item.name" />
                    </div>
                  </template>
                </template>
              </v-autocomplete>

              <div style="margin-left:16px">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                      v-on:click:date="dateRangeSelect"
                    ></v-date-picker>

                    <v-divider></v-divider>

                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="menu_date_picker = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="menu_date_picker = false">Save</v-btn>
                    </v-card-actions> -->
                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>

              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:16px;"
              ></v-select>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>

          <div>
            
          </div>
        </v-app-bar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel work area -->
        <v-card
          color="elevation-0"
          class="panel-invoices"
        >
          <v-card
            color="elevation-1"
            width="100%"
            class="time-sheet-table"
            style="margin-bottom:3px;"
            tile
          >
            <!-- headers -->
            <v-card
              color="elevation-1"
              class="time-sheet-table__header"
              style="margin-bottom:2px;"
              tile
            >
              <v-row no-gutters>
                <v-col>Period</v-col>
                <v-col>Number</v-col>
                <v-col>Location</v-col>
                <v-col>Сommission</v-col>
                <v-col></v-col>
              </v-row>
            </v-card>
            <!--/ headers -->
            <!-- body -->
            <v-card
              color="elevation-1"
              style="margin-bottom: 1px;"
              no-gutters
              tile
              class="time-sheet-table__line"
              v-for="item in invoicesSeached"
              :key="item.id"
             >
              <v-row align="stretch">
                <v-col>{{item.period_date_from | headerDate}} to {{item.period_date_to | headerDate}}</v-col>
                <v-col>{{item.invoice_number}}</v-col>
                <v-col>{{getRestaurantNameByID(item.restaurant_id)}}, {{getAreaLabel(item.restaurant_id)}}</v-col>
                <v-col>
                  {{item.comission}}
                </v-col>
                <v-col>
                  <v-btn v-on:click="onViewInvocie(item)" :loading="localLoading">
                    <v-icon>mdi-file-document-outline</v-icon>&nbsp;View
                  </v-btn>
                  <v-btn v-on:click="onDownloadInvocie(item)" :disabled="localLoading" :loading="localLoading" class="ml-2">
                    <v-icon>mdi-file-document-outline</v-icon>&nbsp;Download
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <!--/ body -->
          </v-card>
          <!--/ right panel work area -->

        </v-card>
      </div>
      <!--/ body -->
    </v-col>
    <v-col v-if="is_mobile_version">
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-toolbar dense color="elevation-1 tool-bar__actions-panel header-btn-panel header-btn-panel-mobile">
          <v-row
            class="d-flex mb-auto"
          >
            <div class="menu-date__picker-mobile">
              <v-btn @click="onPreviosRange">
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>

              <v-menu
                v-model="menu_date_picker"
                transition="scale-transition"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on">
                    {{dateRangeText(date_range_selected)}}
                  </v-btn>
                </template>

                <v-card max-width="346px">
                  <v-date-picker
                    v-model="date_range_selected"
                    scrollable
                    actions
                    full-width
                    first-day-of-week="1"
                    range
                    :title-date-format="dateRangeText"
                    v-on:click:date="dateRangeSelect"
                  ></v-date-picker>

                  <v-divider></v-divider>
                </v-card>
              </v-menu>

              <v-btn @click="onNextRange">
                <v-icon>mdi-menu-right</v-icon>
              </v-btn>
            </div>
            
            <div class="menu-interval-changer-mobile">
              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
              ></v-select>
            </div>

            <div class="menu-restaurant-changer-mobile">
              <v-select
                v-model="restaurant_id_mobile_selected"
                :items="restaurantListSearched"
                item-text="name"
                item-value="id"
                @change="onSelectRestaurantMobile"
                dense
                solo
                hide-details
              ></v-select>
            </div>

          </v-row>
          
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <v-card
        color="elevation-1"
        style="margin-bottom: 2px;"
        no-gutters
        tile
        class="time-sheet-table__line"
        v-for="item in invoicesSeached"
        :key="item.id"
        >
        <v-row>
          <v-col>
            <div class="light-green--text period_date__text-fix">
              Period {{item.period_date_from | headerDate}} to {{item.period_date_to | headerDate}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row>
              <v-col>
                <b>Number:</b> {{item.invoice_number}}<br>
                <b>Сommission:</b> {{item.comission}}<br>
                {{getRestaurantNameByID(item.restaurant_id)}}
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row>
              <v-col>
                <v-btn v-on:click="onDownloadInvocie(item)" :disabled="localLoading" :loading="localLoading" class="large-button__download-fix">
                  <v-row>
                    <v-col>
                      <v-icon>mdi-file-document-outline</v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      Download
                    </v-col>
                  </v-row>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <!--/ body -->
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import { TYPE_AREA, TYPE_RESTAURANT } from '../../store/areas';
import { DATE_RANGE_HELPERS,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH
       } from '../../store/shifts';

export default {
  name: "Invoices",
  data: () => ({
    // const list for template
    TYPE_AREA: TYPE_AREA,
    TYPE_RESTAURANT: TYPE_RESTAURANT,
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      { id: INTERVAL_MONTH, name: 'Month' },
    ],
    // ---
    localLoading: false,
    date_range_selected: null,
    period_date_selected: null,
    menu_date_picker: false,
    location_selected: void 0,
    interval_selected_id: INTERVAL_WEEK, // default week
    area_list: [{
      name: 'All restaurants',
      type: TYPE_AREA,
      _guid: { // fix, group unique id for select
          // id: void 0,
          type: TYPE_AREA
      }
    }],
    restaurant_list: [],
    is_mobile_version: false,
    restaurant_id_mobile_selected: void 0,
    restaurant_item_mobile_selected: void 0,
  }),
  created() {
    // -- detect mobile version
    let check = false;
    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    this.is_mobile_version = check;
  },
  computed: {
    ...mapGetters({
      // locations_list: 'locations',
      // area_list: 'areas',
      // restaurant_list: 'restaurants',
      invoices_list: 'invoices'
    }),
    locations_list() {
      let locations = [];
      locations.push(this.area_list[0]); // put all restaurants into one area
      
      _.each(this.restaurant_list, restaurant => {
          restaurant._guid = {
              id: restaurant.id,
              type: TYPE_RESTAURANT
          };

          locations.push(restaurant);
      });

      return locations;
    },
    restaurantListSearched() {
      if (!this.$data.location_selected) {
        return this.restaurant_list;
      }

      if (this.$data.location_selected.type == TYPE_RESTAURANT) {
        // filter by one restaurant
        let restaurant = _.find(this.restaurant_list, p => p.id == this.$data.location_selected.id)
        if (restaurant) {
          return [restaurant];
        }
        return [];
      }

      return this.restaurant_list;
    },
    invoicesSeached() {
      let result = this.invoices_list;

      if (this.$data.location_selected !== void 0) {
        let restaurant_ids = _.map(this.restaurantListSearched, p => +p.id);
        result = _.filter(result, p => restaurant_ids.indexOf(+p.restaurant_id) !== -1);
      }

      result = _.orderBy(result, p => p.period_date_from);

      return result;
    }
  },
  watch: {
    period_date: function(period_date_new) {
      if (this.$data.period_date_selected != period_date_new) {
        this.$data.period_date_selected = period_date_new;
      }
    },
  },
  mounted() {
    // moment.locale(['ru', 'en']);
    let current_date = moment();
    // this.$data.interval_selected_id = this.$data.interval_list[1].id; // 1 - one week
    this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];

    this.dateRangeSelect();

    // load restaurants list from restaurateur's user data
    let user = JSON.parse(localStorage.getItem("user"));

    let restaurants = [];
    _.each(user.restaurants, restaurant => {
      restaurants.push({
        id: restaurant.id,
        name: restaurant.name,
        contact_name: restaurant.contact_name,
        email: user.email,
        type: TYPE_RESTAURANT,
      });
    });

    this.restaurant_list = restaurants;

    if (!this.restaurant_item_mobile_selected && this.restaurantListSearched.length > 0) {
      this.restaurant_id_mobile_selected = this.restaurantListSearched[0].id;
      this.onSelectRestaurantMobile(this.restaurant_id_mobile_selected);
    }
  },
  methods: {
    dateRangeSelect: async function() {
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);

      // fetch shifts from server
      await Promise.all([
        this.$store.dispatch('fetchInvoices', {
          period_date_from: this.$data.date_range_selected[0],
          period_date_to: this.$data.date_range_selected[1],
          // with_timesheet: '1'
        }),
      ]);
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
        // let date_to_shift_start = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        // let date_to_shift_end = moment(this.$data.date_range_selected[1], "YYYY-MM-DD");
        // if (date_to_shift_start < current_day && current_day < date_to_shift_end) {
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
        // } else {
        //   this.$data.date_range_selected = [date_to_shift_start.format("YYYY-MM-DD"), null];
        // }
      }

      Vue.nextTick(() => {
        this.dateRangeSelect();
      });
    },
    onSelectRestaurantMobile: function(r_id) {
      this.restaurant_item_mobile_selected = _.find(this.restaurantListSearched, p => p.id == r_id);
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'day');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    getAreaLabel: function(restaurant_id) {
      let restaurant = _.find(this.restaurant_list, p => +p.id == +restaurant_id);
      if (!restaurant) {
        return '-'; // impossible
      }

      let area = _.find(this.area_list, p => +p.id == +restaurant.area_id);
      if (!area) {
        return '-'; // impossible
      }

      return area.name;
    },
    // -- helpers:
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getPeriodDateText: function (period_date_selected) {
      return moment(period_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    getRestaurantNameByID: function(restaurant_id) {
      let resturant = _.find(this.restaurant_list, p => +restaurant_id == +p.id);
      if (!resturant) {
        return '-';
      }

      return resturant.name;
    },
    onDownloadInvocie: function(invoice) {
      this.localLoading = true;
      this.$store.dispatch('downloadInvoice', {
          id: invoice.id,
          invoice_number: invoice.invoice_number,
          period_date_from: invoice.period_date_from,
          period_date_to: invoice.period_date_to
      }).then(() => {
          //
      }).finally(() => {
          this.localLoading = false;
      });
    },
    onViewInvocie: function(invoice) {
      this.localLoading = true;
      this.$store.dispatch('viewInvocie', {
          id: invoice.id,
          // invoice_number: invoice.invoice_number,
          // period_date_from: invoice.period_date_from,
          // period_date_to: invoice.period_date_to
      }).then(() => {
          //
      }).finally(() => {
          this.localLoading = false;
      });
    },
  },
  filters: {
    headerDate: function (date) {
      return moment(date, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
  },
}
</script>

<style scoped>
  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }

  .header-btn-panel-mobile {
    padding: 6px 0 6px;
  }

  .menu-date__picker-mobile {
    margin-bottom: 6px;
  }

  .period_date__text-fix {
    font-size: 14px;
  }

  .large-button__download-fix {
    height: 56px !important;
  }
</style>

<style>
  /* see more in src\components\Invoices\Invoices.vue */
</style>
